import { FormattedMessage } from "react-intl";
import SelectFormik from "app/pages/.shared/form/SelectFormik";
import { useCountries } from "app/utils/intl/useCountries";
import { memo } from "react";
import "./Nationality.scss";

const NationalityFormik = () => {
	const countries = useCountries();

	return (
		<div className="nationality">
			<SelectFormik
				id="nationality"
				name="nationality"
				label={<FormattedMessage id="nationality.label" />}
				data-testid="nationality-select-input"
			>
				<option />
				{countries.map(country => (
					<option key={country.cca2} value={country.cca2}>
						{country.name}
					</option>
				))}
			</SelectFormik>
		</div>
	);
};

export default memo(NationalityFormik);
